import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitSelectedPartnerIds = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) => filter.selectedPartnerIds
)
